import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BillerSharedData {
    billerName?: string;
    providerId?: string;
    billerAccount?: string;
    [key: string]: unknown;
}

@Injectable({
    providedIn: 'root'
})
export class BillersSharedDataService {
    // private secretKey = 'HU7kK2VJKSlHZlZ2ZFjpWzc=OXTtel03VydOOGtIbWE4Z540WlJyDjt+en1MbEx7WGstcmL1SzZ7AiPGeCt3JlN2PSUweFU5aHVYYmBufTYUDFlKLkAlLHDlBw==VzFzUT0kGiS8';
    billerDataObj: BillerSharedData | null = null;

    private dataSource = new BehaviorSubject<BillerSharedData | null>(null);
    currentData = this.dataSource.asObservable();

    updateData(data: BillerSharedData) {
        this.dataSource.next(data);
    }

    setBillerData(data: BillerSharedData) {
        this.billerDataObj = data;
    }

    resetBillerData() {
        this.billerDataObj = null;
    }

    // storeBillerData(data: any) {
    //     const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
    //     localStorage.setItem('biller_info', encryptedData);
    // }

    // getBillerData() {
    //     const storedBillerData = localStorage.getItem('biller_info') || null;

    //     const bytes = CryptoJS.AES.decrypt(storedBillerData, this.secretKey);
    //     const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    //     return decryptedData;
    // }
}
